<div class="px-6 py-6">

  <!-- Header -->
  <div class="flex items-center justify-between mb-6">
    <div>
      <h1 class="text-2xl font-bold text-gray-900">
        <i class="fas fa-credit-card mr-2 text-cyan-500"></i>
        Transacciones 3DS
      </h1>
      <p class="text-sm text-gray-500 mt-1">Auditoria y gestion de pagos con tarjeta internacional (CROEM)</p>
    </div>
    <!-- Tabs -->
    <div class="flex space-x-1 bg-gray-100 rounded-lg p-1">
      <button
        (click)="onTabChange('transactions')"
        [class.bg-white]="activeTab === 'transactions'"
        [class.shadow-sm]="activeTab === 'transactions'"
        [class.text-gray-900]="activeTab === 'transactions'"
        [class.text-gray-500]="activeTab !== 'transactions'"
        class="px-4 py-2 text-sm font-medium rounded-md transition-all">
        <i class="fas fa-list mr-1"></i> Transacciones
      </button>
      <button
        (click)="onTabChange('config')"
        [class.bg-white]="activeTab === 'config'"
        [class.shadow-sm]="activeTab === 'config'"
        [class.text-gray-900]="activeTab === 'config'"
        [class.text-gray-500]="activeTab !== 'config'"
        class="px-4 py-2 text-sm font-medium rounded-md transition-all">
        <i class="fas fa-cog mr-1"></i> Configuracion
      </button>
    </div>
  </div>

  <!-- ============================================================ -->
  <!-- TAB: Transacciones -->
  <!-- ============================================================ -->
  <div *ngIf="activeTab === 'transactions'">

    <!-- KPIs -->
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-4 mb-6">
      <!-- Total -->
      <div class="bg-white rounded-xl shadow-sm border border-gray-200 p-4">
        <div class="flex items-center justify-between">
          <div>
            <p class="text-xs font-medium text-gray-500 uppercase">Total</p>
            <p class="text-2xl font-bold text-gray-900">{{ stats.totalTransactions || 0 }}</p>
          </div>
          <div class="w-10 h-10 rounded-lg bg-blue-50 flex items-center justify-center">
            <i class="fas fa-exchange-alt text-blue-500"></i>
          </div>
        </div>
      </div>

      <!-- Completadas -->
      <div class="bg-white rounded-xl shadow-sm border border-gray-200 p-4">
        <div class="flex items-center justify-between">
          <div>
            <p class="text-xs font-medium text-gray-500 uppercase">Completadas</p>
            <p class="text-2xl font-bold text-green-600">{{ stats.completed || 0 }}</p>
            <p class="text-xs text-gray-400">{{ formatUsd(stats.completedAmount) }}</p>
          </div>
          <div class="w-10 h-10 rounded-lg bg-green-50 flex items-center justify-center">
            <i class="fas fa-check-circle text-green-500"></i>
          </div>
        </div>
      </div>

      <!-- Fallidas -->
      <div class="bg-white rounded-xl shadow-sm border border-gray-200 p-4">
        <div class="flex items-center justify-between">
          <div>
            <p class="text-xs font-medium text-gray-500 uppercase">Fallidas</p>
            <p class="text-2xl font-bold text-red-600">{{ stats.failed || 0 }}</p>
          </div>
          <div class="w-10 h-10 rounded-lg bg-red-50 flex items-center justify-center">
            <i class="fas fa-times-circle text-red-500"></i>
          </div>
        </div>
      </div>

      <!-- Pendientes -->
      <div class="bg-white rounded-xl shadow-sm border border-gray-200 p-4">
        <div class="flex items-center justify-between">
          <div>
            <p class="text-xs font-medium text-gray-500 uppercase">Pendientes</p>
            <p class="text-2xl font-bold text-yellow-600">{{ stats.pending || 0 }}</p>
          </div>
          <div class="w-10 h-10 rounded-lg bg-yellow-50 flex items-center justify-center">
            <i class="fas fa-clock text-yellow-500"></i>
          </div>
        </div>
      </div>

      <!-- Tasa exito -->
      <div class="bg-white rounded-xl shadow-sm border border-gray-200 p-4">
        <div class="flex items-center justify-between">
          <div>
            <p class="text-xs font-medium text-gray-500 uppercase">Tasa de Exito</p>
            <p class="text-2xl font-bold text-cyan-600">{{ stats.successRate || 0 }}%</p>
            <p class="text-xs text-gray-400">{{ formatUsd(stats.totalAmountUsd) }} total</p>
          </div>
          <div class="w-10 h-10 rounded-lg bg-cyan-50 flex items-center justify-center">
            <i class="fas fa-chart-pie text-cyan-500"></i>
          </div>
        </div>
      </div>

      <!-- Vinculados a Credito -->
      <div class="bg-white rounded-xl shadow-sm border border-gray-200 p-4">
        <div class="flex items-center justify-between">
          <div>
            <p class="text-xs font-medium text-gray-500 uppercase">Vinculados</p>
            <p class="text-2xl font-bold text-purple-600">{{ stats.linkedToCredit || 0 }}</p>
            <p class="text-xs text-gray-400">de {{ stats.completed || 0 }} completadas</p>
          </div>
          <div class="w-10 h-10 rounded-lg bg-purple-50 flex items-center justify-center">
            <i class="fas fa-link text-purple-500"></i>
          </div>
        </div>
      </div>
    </div>

    <!-- Filtros -->
    <div class="bg-white rounded-xl shadow-sm border border-gray-200 p-4 mb-6">
      <div class="grid grid-cols-1 md:grid-cols-5 gap-4 items-end">
        <!-- Busqueda -->
        <div>
          <label class="block text-xs font-medium text-gray-600 mb-1">Buscar</label>
          <input
            type="text"
            [(ngModel)]="filters.search"
            (keyup.enter)="applyFilters()"
            placeholder="Tracking, ID, persona..."
            class="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-cyan-500 focus:border-cyan-500">
        </div>

        <!-- Estado -->
        <div>
          <label class="block text-xs font-medium text-gray-600 mb-1">Estado</label>
          <select
            [(ngModel)]="filters.status"
            (change)="applyFilters()"
            class="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-cyan-500 focus:border-cyan-500">
            <option *ngFor="let s of statuses" [value]="s.value">{{ s.label }}</option>
          </select>
        </div>

        <!-- Fecha desde -->
        <div>
          <label class="block text-xs font-medium text-gray-600 mb-1">Desde</label>
          <input
            type="date"
            [(ngModel)]="filters.dateFrom"
            (change)="applyFilters()"
            class="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-cyan-500 focus:border-cyan-500">
        </div>

        <!-- Fecha hasta -->
        <div>
          <label class="block text-xs font-medium text-gray-600 mb-1">Hasta</label>
          <input
            type="date"
            [(ngModel)]="filters.dateTo"
            (change)="applyFilters()"
            class="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-cyan-500 focus:border-cyan-500">
        </div>

        <!-- Acciones -->
        <div class="flex space-x-2">
          <button
            (click)="applyFilters()"
            class="px-4 py-2 bg-cyan-500 text-white text-sm font-medium rounded-lg hover:bg-cyan-600 transition-colors">
            <i class="fas fa-search mr-1"></i> Buscar
          </button>
          <button
            (click)="clearFilters()"
            class="px-4 py-2 bg-gray-100 text-gray-600 text-sm font-medium rounded-lg hover:bg-gray-200 transition-colors">
            <i class="fas fa-eraser mr-1"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- Tabla de transacciones -->
    <div class="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">

      <!-- Loading -->
      <div *ngIf="loadingTransactions" class="p-8 text-center">
        <i class="fas fa-spinner fa-spin text-2xl text-cyan-500"></i>
        <p class="text-sm text-gray-500 mt-2">Cargando transacciones...</p>
      </div>

      <!-- Tabla -->
      <div *ngIf="!loadingTransactions" class="overflow-x-auto">
        <table class="w-full text-sm">
          <thead>
            <tr class="bg-gray-50 border-b border-gray-200">
              <th class="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase">Fecha</th>
              <th class="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase">Tracking</th>
              <th class="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase">Persona</th>
              <th class="px-4 py-3 text-right text-xs font-semibold text-gray-500 uppercase">Monto USD</th>
              <th class="px-4 py-3 text-center text-xs font-semibold text-gray-500 uppercase">Estado</th>
              <th class="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase">Cod. Resp</th>
              <th class="px-4 py-3 text-center text-xs font-semibold text-gray-500 uppercase">Pago Credito</th>
              <th class="px-4 py-3 text-center text-xs font-semibold text-gray-500 uppercase">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let txn of transactions; let i = index"
              class="border-b border-gray-100 hover:bg-gray-50 transition-colors cursor-pointer"
              (click)="openDetail(txn, detailModal)">
              <td class="px-4 py-3 text-gray-600">{{ formatDate(txn.createdAt) }}</td>
              <td class="px-4 py-3">
                <span class="font-mono text-xs text-gray-700">{{ txn.clientTracking }}</span>
              </td>
              <td class="px-4 py-3 text-gray-700">{{ txn.personCode }}</td>
              <td class="px-4 py-3 text-right font-semibold text-gray-900">{{ formatUsd(txn.amountUsd) }}</td>
              <td class="px-4 py-3 text-center">
                <span class="inline-flex px-2 py-1 text-xs font-medium rounded-full"
                  [ngClass]="getStatusClass(txn.status)">
                  {{ getStatusLabel(txn.status) }}
                </span>
              </td>
              <td class="px-4 py-3">
                <span class="font-mono text-xs" [class.text-green-600]="txn.responseCode === '00'" [class.text-red-600]="txn.responseCode && txn.responseCode !== '00'">
                  {{ txn.responseCode || '-' }}
                </span>
              </td>
              <td class="px-4 py-3 text-center" (click)="$event.stopPropagation()">
                <!-- Vinculado -->
                <span *ngIf="isLinked(txn)" class="inline-flex items-center px-2 py-1 text-xs font-medium rounded-full bg-green-100 text-green-800">
                  <i class="fas fa-link mr-1"></i> {{ txn.kreditPaymentCode }}
                </span>
                <!-- Puede registrar -->
                <button *ngIf="canRegister(txn)"
                  (click)="registerPayment(txn)"
                  [disabled]="registeringPayment[txn.clientTracking]"
                  class="inline-flex items-center px-2 py-1 text-xs font-medium rounded-full bg-yellow-100 text-yellow-800 hover:bg-yellow-200 transition-colors">
                  <i class="fas fa-plus-circle mr-1" *ngIf="!registeringPayment[txn.clientTracking]"></i>
                  <i class="fas fa-spinner fa-spin mr-1" *ngIf="registeringPayment[txn.clientTracking]"></i>
                  Registrar
                </button>
                <!-- No aplica -->
                <span *ngIf="txn.status !== 'SALE_COMPLETED'" class="text-xs text-gray-400">-</span>
              </td>
              <td class="px-4 py-3 text-center">
                <button class="text-cyan-500 hover:text-cyan-700">
                  <i class="fas fa-eye"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <!-- Empty state -->
        <div *ngIf="transactions.length === 0" class="p-12 text-center">
          <i class="fas fa-inbox text-4xl text-gray-300"></i>
          <p class="text-gray-500 mt-3">No hay transacciones con los filtros seleccionados</p>
        </div>
      </div>

      <!-- Paginacion -->
      <div *ngIf="pagination.pages > 1" class="flex items-center justify-between px-4 py-3 border-t border-gray-200 bg-gray-50">
        <div class="text-xs text-gray-500">
          Mostrando {{ ((pagination.page - 1) * pagination.limit) + 1 }} - {{ pagination.page * pagination.limit > pagination.total ? pagination.total : pagination.page * pagination.limit }} de {{ pagination.total }}
        </div>
        <div class="flex space-x-1">
          <button
            (click)="goToPage(pagination.page - 1)"
            [disabled]="pagination.page === 1"
            class="px-3 py-1 text-sm border rounded-md disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-100">
            <i class="fas fa-chevron-left"></i>
          </button>
          <button
            *ngFor="let p of visiblePages"
            (click)="goToPage(p)"
            [class.bg-cyan-500]="p === pagination.page"
            [class.text-white]="p === pagination.page"
            [class.border-cyan-500]="p === pagination.page"
            class="px-3 py-1 text-sm border rounded-md hover:bg-gray-100">
            {{ p }}
          </button>
          <button
            (click)="goToPage(pagination.page + 1)"
            [disabled]="pagination.page === pagination.pages"
            class="px-3 py-1 text-sm border rounded-md disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-100">
            <i class="fas fa-chevron-right"></i>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- ============================================================ -->
  <!-- TAB: Configuracion -->
  <!-- ============================================================ -->
  <div *ngIf="activeTab === 'config'">
    <div class="bg-white rounded-xl shadow-sm border border-gray-200 p-6">

      <div *ngIf="loadingConfig" class="text-center py-8">
        <i class="fas fa-spinner fa-spin text-2xl text-cyan-500"></i>
      </div>

      <div *ngIf="!loadingConfig">
        <h2 class="text-lg font-semibold text-gray-900 mb-4">
          <i class="fas fa-sliders-h mr-2 text-gray-400"></i>Configuracion CROEM 3DS
        </h2>

        <!-- Activar/Desactivar -->
        <div class="flex items-center justify-between p-4 bg-gray-50 rounded-lg mb-4">
          <div>
            <p class="font-medium text-gray-900">Pagos con tarjeta internacional</p>
            <p class="text-sm text-gray-500">Activar o desactivar el flujo 3DS para todos los usuarios</p>
          </div>
          <button
            (click)="toggleActive()"
            [class.bg-green-500]="config?.croem_3ds_active?.value === true"
            [class.bg-gray-300]="config?.croem_3ds_active?.value !== true"
            class="relative inline-flex h-6 w-11 items-center rounded-full transition-colors">
            <span
              [class.translate-x-6]="config?.croem_3ds_active?.value === true"
              [class.translate-x-1]="config?.croem_3ds_active?.value !== true"
              class="inline-block h-4 w-4 rounded-full bg-white transition-transform shadow-sm">
            </span>
          </button>
        </div>

        <!-- Monto maximo -->
        <div class="flex items-center justify-between p-4 bg-gray-50 rounded-lg mb-4">
          <div>
            <p class="font-medium text-gray-900">Monto maximo por transaccion (USD)</p>
            <p class="text-sm text-gray-500">Limite superior permitido por pago individual</p>
          </div>
          <div class="flex items-center space-x-2">
            <input
              type="number"
              [value]="config?.croem_3ds_max_amount?.value || 10000"
              #maxAmountInput
              min="1"
              class="w-28 px-3 py-1.5 border border-gray-300 rounded-lg text-sm text-right">
            <button
              (click)="saveConfigValue('croem_3ds_max_amount', +maxAmountInput.value, 'Monto maximo USD por transaccion')"
              class="px-3 py-1.5 bg-cyan-500 text-white text-sm rounded-lg hover:bg-cyan-600">
              <i class="fas fa-save"></i>
            </button>
          </div>
        </div>

        <!-- Monto minimo -->
        <div class="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
          <div>
            <p class="font-medium text-gray-900">Monto minimo por transaccion (USD)</p>
            <p class="text-sm text-gray-500">Limite inferior permitido por pago individual</p>
          </div>
          <div class="flex items-center space-x-2">
            <input
              type="number"
              [value]="config?.croem_3ds_min_amount?.value || 0.50"
              #minAmountInput
              min="0.01"
              step="0.01"
              class="w-28 px-3 py-1.5 border border-gray-300 rounded-lg text-sm text-right">
            <button
              (click)="saveConfigValue('croem_3ds_min_amount', +minAmountInput.value, 'Monto minimo USD por transaccion')"
              class="px-3 py-1.5 bg-cyan-500 text-white text-sm rounded-lg hover:bg-cyan-600">
              <i class="fas fa-save"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>

<!-- ============================================================ -->
<!-- Modal: Detalle de transaccion -->
<!-- ============================================================ -->
<ng-template #detailModal let-modal>
  <div class="modal-header bg-gray-50 border-b">
    <h5 class="modal-title font-semibold text-gray-900">
      <i class="fas fa-receipt mr-2 text-cyan-500"></i>Detalle de Transaccion
    </h5>
    <button type="button" class="btn-close" (click)="modal.close()"></button>
  </div>
  <div class="modal-body p-0">

    <div *ngIf="loadingDetail" class="p-8 text-center">
      <i class="fas fa-spinner fa-spin text-xl text-cyan-500"></i>
    </div>

    <div *ngIf="!loadingDetail && selectedTransaction">
      <!-- Info principal -->
      <div class="p-4 border-b">
        <div class="grid grid-cols-2 gap-3 text-sm">
          <div>
            <span class="text-gray-500">Tracking:</span>
            <span class="ml-1 font-mono font-medium">{{ selectedTransaction.clientTracking }}</span>
          </div>
          <div>
            <span class="text-gray-500">Estado:</span>
            <span class="ml-1 inline-flex px-2 py-0.5 text-xs font-medium rounded-full"
              [ngClass]="getStatusClass(selectedTransaction.status)">
              {{ getStatusLabel(selectedTransaction.status) }}
            </span>
          </div>
          <div>
            <span class="text-gray-500">Persona:</span>
            <span class="ml-1 font-medium">{{ selectedTransaction.personCode }}</span>
          </div>
          <div>
            <span class="text-gray-500">Monto:</span>
            <span class="ml-1 font-bold text-gray-900">{{ formatUsd(selectedTransaction.amountUsd) }}</span>
          </div>
          <div>
            <span class="text-gray-500">Flujo:</span>
            <span class="ml-1">{{ selectedTransaction.flowType || '-' }}</span>
          </div>
          <div>
            <span class="text-gray-500">Cod. Respuesta:</span>
            <span class="ml-1 font-mono">{{ selectedTransaction.responseCode || '-' }}</span>
          </div>
          <div>
            <span class="text-gray-500">Transaction ID:</span>
            <span class="ml-1 font-mono">{{ selectedTransaction.transactionId || '-' }}</span>
          </div>
          <div>
            <span class="text-gray-500">Autorizacion:</span>
            <span class="ml-1 font-mono">{{ selectedTransaction.authorizationNumber || '-' }}</span>
          </div>
          <div>
            <span class="text-gray-500">Creado:</span>
            <span class="ml-1">{{ formatDate(selectedTransaction.createdAt) }}</span>
          </div>
          <div>
            <span class="text-gray-500">Intentos:</span>
            <span class="ml-1">{{ selectedTransaction.attempts || 0 }}</span>
          </div>
          <!-- Pago en credito -->
          <div class="col-span-2" *ngIf="isLinked(selectedTransaction)">
            <span class="text-gray-500">Pago en Credito:</span>
            <span class="ml-1 inline-flex items-center px-2 py-0.5 text-xs font-medium rounded-full bg-green-100 text-green-800">
              <i class="fas fa-link mr-1"></i> {{ selectedTransaction.kreditPaymentCode }}
            </span>
          </div>
          <div class="col-span-2" *ngIf="canRegister(selectedTransaction)">
            <button
              (click)="registerPayment(selectedTransaction)"
              [disabled]="registeringPayment[selectedTransaction.clientTracking]"
              class="px-4 py-2 bg-cyan-500 text-white text-sm font-medium rounded-lg hover:bg-cyan-600 transition-colors">
              <i class="fas fa-plus-circle mr-1" *ngIf="!registeringPayment[selectedTransaction.clientTracking]"></i>
              <i class="fas fa-spinner fa-spin mr-1" *ngIf="registeringPayment[selectedTransaction.clientTracking]"></i>
              Registrar Pago en Credito
            </button>
          </div>
        </div>

        <!-- Error detail -->
        <div *ngIf="selectedTransaction.errorDetail" class="mt-3 p-3 bg-red-50 rounded-lg text-sm text-red-700">
          <i class="fas fa-exclamation-triangle mr-1"></i>
          {{ selectedTransaction.errorDetail }}
        </div>

        <!-- Response description -->
        <div *ngIf="selectedTransaction.responseDescription" class="mt-3 p-3 bg-gray-50 rounded-lg text-sm text-gray-600">
          <i class="fas fa-info-circle mr-1"></i>
          {{ selectedTransaction.responseDescription }}
        </div>
      </div>

      <!-- Audit Trail -->
      <div class="p-4">
        <h6 class="font-semibold text-gray-700 mb-3">
          <i class="fas fa-history mr-1 text-gray-400"></i> Bitacora
        </h6>

        <div *ngIf="auditTrail.length === 0" class="text-sm text-gray-400 text-center py-4">
          Sin registros de bitacora
        </div>

        <div *ngFor="let entry of auditTrail; let i = index" class="mb-3">
          <div class="flex items-start space-x-3">
            <div class="flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold"
              [class.bg-blue-100]="entry.tipo === '3ds-authenticate'"
              [class.text-blue-600]="entry.tipo === '3ds-authenticate'"
              [class.bg-green-100]="entry.tipo === '3ds-sale'"
              [class.text-green-600]="entry.tipo === '3ds-sale'">
              {{ i + 1 }}
            </div>
            <div class="flex-1 min-w-0">
              <div class="flex items-center justify-between">
                <span class="text-sm font-medium text-gray-900">{{ entry.tipo }}</span>
                <span class="text-xs text-gray-400">{{ formatDate(entry.timestamp) }}</span>
              </div>
              <p class="text-xs text-gray-500 mt-0.5">{{ entry.endpoint }} → {{ entry.urlRequest }}</p>
              <div class="mt-1 p-2 bg-gray-50 rounded text-xs font-mono text-gray-600 max-h-32 overflow-auto">
                <span class="font-semibold">HTTP {{ entry.statusResponse }}:</span>
                {{ entry.responseBody | json }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer bg-gray-50">
    <button type="button" class="btn btn-sm btn-secondary" (click)="modal.close()">Cerrar</button>
  </div>
</ng-template>
